import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'sourceGroupGeneralInfo';
export const useSourceGroupGeneralInfoTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => useTranslation('widgets', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    title: 'Общая информация',
    fields: {
      group_name: 'Название',
      description: 'Описание',
      owner_department: 'Подразделение-владелец',
      permission_tag: 'Тег разрешений',
      choose_permission_tag: 'Выбрать тег',
      group_id: 'ID группы',
    },
    validation: {
      required: 'Обязательное поле',
      name_pattern: 'Допустимы латиница, цифры, «_», «-»',
    },
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'General information',
    fields: {
      group_name: 'Name',
      description: 'Description',
      owner_department: 'Owner department',
      permission_tag: 'Permission tag',
      choose_permission_tag: 'Choose tag',
      group_id: 'Group ID',
    },
    validation: {
      required: 'Required field',
      name_pattern: 'Latin letters, digits, «_», «-» are allowed',
    },
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Información general',
    fields: {
      group_name: 'Nombre',
      description: 'Descripción',
      owner_department: 'Departamento propietario',
      permission_tag: 'Etiqueta de permisos',
      choose_permission_tag: 'Elegir etiqueta',
      group_id: 'ID del grupo',
    },
    validation: {
      required: 'Campo obligatorio',
      name_pattern: 'Se permiten letras latinas, dígitos, «_», «-»',
    },
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Informações gerais',
    fields: {
      group_name: 'Nome',
      description: 'Descrição',
      owner_department: 'Departamento proprietário',
      permission_tag: 'Tag de permissões',
      choose_permission_tag: 'Escolher etiqueta',
      group_id: 'ID do grupo',
    },
    validation: {
      required: 'Campo obrigatório',
      name_pattern: 'São permitidas letras latinas, dígitos, «_», «-»',
    },
  },
}) as Record<string, unknown>;
